<template>
    <ul class="thumbnail-list">
        <template v-if="pending">
            <li
                v-for="item in [1,2,3,4]"
                :key="item"
                class="thumbnail-list__item"
            >
                <div class="thumbnail-list__image">
                    <Skeletor
                        class="thumbnail-list__image-fallback"
                        height="50px"
                        width="50px"
                    />
                </div>

                <span class="thumbnail-list__label">
                    <Skeletor
                        width="100%"
                        :shimmer="false"
                    />
                </span>
            </li>
        </template>
        <template v-else>
            <li
                v-for="(item, index) in items"
                :key="index"
                class="thumbnail-list__item"
                :class="{
                    'thumbnail-list__item--active': activeItem === item,
                }"
                :tabindex="null"
                @click="$emit('click:item', item)"
                @keydown.enter="null"
            >
                <div class="thumbnail-list__image">
                    <Skeletor
                        class="thumbnail-list__image-fallback"
                        height="50px"
                        width="50px"
                        :shimmer="false"
                    />
                    <BaseImage
                        v-if="item.image?.length"
                        sizes="50px"
                        :image="item.image[0]"
                        fetchpriority="low"
                        :fade-in-view="false"
                    />
                </div>

                <span class="thumbnail-list__label">
                    <slot :name="`item-${index}`" />
                </span>
            </li>
        </template>
    </ul>
</template>

<script setup>
import { Skeletor } from 'vue-skeletor';

defineEmits(['click:item']);
defineProps({
    items: {
        type: Array,
        required: false,
        default: () => []
    },
    pending: {
        type: Boolean,
        default: false
    },
    activeItem: {
        type: Object,
        required: false,
        default: () => null
    }
});
</script>

<style lang="less">
.thumbnail-list {
    .list-clean();
    display: flex;
    flex-direction: column;
    gap: .5rem;
}

.thumbnail-list__item {
    display: flex;
    align-items: center;

    gap: 1rem;

    transition: padding var(--transition-timing-medium) 0ms var(--transition-timingFunction-in-out), background-color var(--transition-timing-medium) 0ms var(--transition-timingFunction-in-out);
    background: rgba(255, 255, 255, 0);
    padding-block: .5rem;

    cursor: pointer;

    &:hover,
    &--active {
        // stylelint-disable-next-line declaration-no-important
        padding: .5rem !important;
        background-color: var(--color-cream);
    }
}

.thumbnail-list__image {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    height: 50px;
    width: 50px;

    .thumbnail-list__image-fallback,
    img {
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .base-image {
        display: inline;
    }

    .thumbnail-list__image-fallback {
        z-index: 1;
    }
}

.thumbnail-list__label {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.thumbnail-list__item--disabled {
    opacity: .5;
    pointer-events: none;
}
</style>
